<template>
  <div class="container mb-5">
    <div class="row">
      <div
        :key="index"
        v-for="(member, index) in boardMembers"
        class="col-6 col-sm-6 col-lg-3 mb-3"
      >
        <div class="portrait mb-4">
          <img :src="`${publicPath}${member.portrait}`" />
        </div>
        <div class="title main-theme">{{ member.title }}</div>
        <div class="subtitle main-theme mb-2">{{ member.subtitle }}</div>

        <div class="position-relative">
          <div :key="index" v-for="(note, index) in member.notes" class="notes text-theme">
            <div>{{ note }}</div>
          </div>
          <div class="position-absolute note-icon" v-if="member.info">
            <div>
              <img
                :id="`tooltip-${index}`"
                src="@/assets/boardmembers/icon_i.svg"
                style="width: 13px"
              />
            </div>
            <b-tooltip :target="`tooltip-${index}`" placement="bottom" variant="danger">
              {{ member.info }}
            </b-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BoardMembersFrames",
  props: {
    boardMembers: Array,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
};
</script>

<style lang="scss" scoped>
.portrait {
  img {
    max-width: 100%;
  }
}
.title {
  font-size: 1.6rem;
  text-shadow: 1px 1px lightgrey;
}
.subtitle {
  min-height: 60px;
  border-bottom: 2px solid #e81b29;
}
.note-icon {
  right: 0;
  bottom: 0;
}
@media (max-width: 1200px) {
  .title {
    font-size: 1.4rem;
  }
}
@media (max-width: 991px) {
  .note-icon {
    right: auto;
    bottom: -20px;
  }
}
@media (max-width: 575px) {
  .title {
    font-size: 4.3vw;
  }
  .subtitle {
    font-size: 3vw;
  }
  .notes {
    font-size: 3.5vw;
  }
}
</style>
